import React from 'react';
import Select from 'react-select';

const multiSelect = (props) => {
	let fieldDetail = JSON.parse(props.fieldDetails);
	console.log(fieldDetail);
	return (
		<Select
			classNamePrefix="form-control"
	        value={fieldDetail.value}
	        isMulti
	        onChange={e=>props.changed(e,props.fieldKey)}
	        options={fieldDetail.options}
	      />
	)
}

export default multiSelect;